import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';
import configuration from 'configuration';

const LangMenu = ({
  show,
  onClickOutside,
  children,
}: {
  show: boolean;
  onClickOutside: () => void;
  children?: React.ReactNode;
}) => {
  const ref = useRef<null | HTMLUListElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (ref.current && !ref.current.contains(event.target)) onClickOutside();
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClickOutside, ref]);

  return show ? <Menu ref={ref}>{children}</Menu> : null;
};

const LangButton = () => {
  const {i18n} = useTranslation();
  const [showMenu, setShowMenu] = useState(false);

  const setLang = useCallback(
    (lang: string) => {
      void i18n.changeLanguage(lang);
      setShowMenu(false);
    },
    [i18n],
  );

  return (
    <>
      <button className="nav-button" onClick={() => setShowMenu(true)}>
        {i18n.language.toUpperCase()}
      </button>
      <LangMenu show={showMenu} onClickOutside={() => setShowMenu(false)}>
        {configuration.languages
          .filter(l => l !== i18n.language)
          .map(l => (
            <MenuItem key={l} className="no-select" onClick={() => setLang(l)}>
              {l.toUpperCase()}
            </MenuItem>
          ))}
      </LangMenu>
    </>
  );
};
export default LangButton;

const Menu = styled.ul`
  box-sizing: border-box;
  position: absolute;
  right: 0;
  top: calc(var(--nav-bar-height) + 1px);
  margin: 0;
  padding: var(--margin);
  z-index: 9999;
  background: white;
  border: 1px solid var(--color-border);
  box-shadow: -2px 2px 5px rgba(0, 0, 0, 0.5);
  list-style-type: none;
`;

const MenuItem = styled.li`
  padding: 5px 5px 5px calc(var(--margin) * 2);
  font-size: 15px;
  color: var(--color-text);
  white-space: nowrap;
  cursor: pointer;

  body:not(.philo-screen) &:hover {
    color: var(--color-blue);
  }

  &:active {
    color: white;
    background: var(--color-blue);
  }
`;
